import { render, staticRenderFns } from "./CoachSettingPersonalInfo.vue?vue&type=template&id=1dce996e&"
import script from "./CoachSettingPersonalInfo.vue?vue&type=script&lang=ts&"
export * from "./CoachSettingPersonalInfo.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports